export const allFoods = [ 
{
    "id":"1",
    "name":"Pesarattu" ,
    "image": process.env.PUBLIC_URL + "/assests/Dosa/3g.png",
    "price":"₹65",
    "description":"Healthy and crisp whole green gram crepe, traditionally served with allam (ginger) chutney.",
},
{
    "id": "2",
    "name": "Masala Dosa",
    "image": process.env.PUBLIC_URL + "/assests/Dosa/4k.png",
    "price": "₹40",
    "description": "Crispy crepe filled with spiced potato mixture."
},
{
    "id": "4",
    "name": "Puri",
    "image": process.env.PUBLIC_URL + "/assests/Puri/1.jpg",
    "price": "₹35",
    "description": "Classic thin and crispy crepe made from fermented rice and lentil batter."
},
{
    "id": "5",
    "name": "Bonda",
    "image": process.env.PUBLIC_URL + "/assests/bonda/1.jpg",
    "price": "₹45",
    "description":"Crispy outside and soft inside, traditional fried snack served with spicy ginger chutney."
},
{
    "id": "6",
    "name": "Ghee Idli",
    "image": process.env.PUBLIC_URL + "/assests/idli/3.webp",
    "price": "₹50",
    "description": "Soft and fluffy steamed rice cakes, a South Indian breakfast staple, served with sambar and chutney."
},
{
    "id": "7",
    "name": "Soji Upma",
    "image": process.env.PUBLIC_URL + "/assests/upma/3.png",
    "price": "₹55",
    "description": "Warm, fluffy semolina porridge, subtly spiced with ginger, tempered mustard seeds, and fresh coriander leaves."
},
{
    "id": "8",
    "name": "Egg Dosa",
    "image": process.env.PUBLIC_URL + "/assests/dosa/1e.png",
    "price": "₹70",
    "description": "A delightful variation with a crumbled paneer filling, adding a creamy and savory twist"
},
{
    "id": "9",
    "name": "Oats Upma",
    "image": process.env.PUBLIC_URL + "/assests/upma/2.png",
    "price": "₹70",
    "description": "Healthy and hearty breakfast dish made with oats, vegetables, and aromatic spices."
},
{
    "id": "10",
    "name": "Sambar Idli",
    "image": process.env.PUBLIC_URL + "/assests/idli/3.webp",
    "price": "₹70",
    "description": "Soft idlis soaked in flavorful sambar and served with chutney."
}]